import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function LandingPage() {
  useEffect(() => {
    // Scroll reveal
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible')
          observer.unobserve(e.target)
        }
      })
    }, { threshold: 0.12 })
    document.querySelectorAll('.lp-reveal').forEach(el => observer.observe(el))
    return () => observer.disconnect()
  }, [])

  const [showSignIn, setShowSignIn] = useState(false)
  const [email, setEmail] = useState('')
  const [magicSent, setMagicSent] = useState(false)
  const [magicLoading, setMagicLoading] = useState(false)
  const [magicError, setMagicError] = useState(null)

  const signIn = () => setShowSignIn(true)

  const signInGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin }
    })
  }

  const signInMagic = async (e) => {
    e.preventDefault()
    if (!email.trim()) return
    setMagicLoading(true)
    setMagicError(null)
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { emailRedirectTo: window.location.origin }
    })
    setMagicLoading(false)
    if (error) setMagicError(error.message)
    else setMagicSent(true)
  }

  return (
    <>
      <style>{`
        .lp * { box-sizing: border-box; }
        .lp { font-family: var(--font); background: var(--paper); color: var(--ink); -webkit-font-smoothing: antialiased; }
        .lp-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; display: flex; align-items: center; justify-content: space-between; padding: 0 2.5rem; height: 56px; background: rgba(241,238,231,0.92); backdrop-filter: blur(12px); border-bottom: 1px solid var(--line-2); }
        .lp-logo { font-family: var(--font); font-size: 1.35rem; font-weight: 800; letter-spacing: -0.03em; color: var(--ink); text-decoration: none; }
        .lp-logo span { color: var(--green); }
        .lp-nav-cta { font-family: var(--mono); font-size: 0.68rem; text-transform: uppercase; letter-spacing: 1px; padding: 8px 20px; background: var(--header); color: var(--cream); border: none; border-radius: var(--radius-ctl); cursor: pointer; transition: background 0.15s; }
        .lp-nav-cta:hover { background: var(--header-2); }
        .lp-hero { min-height: 100vh; display: flex; flex-direction: column; justify-content: center; padding: 8rem 2.5rem 5rem; max-width: 1100px; margin: 0 auto; }
        .lp-eyebrow { font-family: var(--mono); font-size: 0.68rem; text-transform: uppercase; letter-spacing: 2px; color: var(--green); margin-bottom: 1.5rem; opacity: 0; animation: lp-fadeUp 0.6s ease 0.1s forwards; }
        .lp-h1 { font-family: var(--font); font-size: clamp(2.8rem, 6vw, 5rem); font-weight: 800; line-height: 1.08; letter-spacing: -0.03em; max-width: 14ch; opacity: 0; animation: lp-fadeUp 0.7s ease 0.2s forwards; }
        .lp-h1 em { font-style: normal; color: var(--green); }
        .lp-sub { margin-top: 1.75rem; font-size: 1.1rem; color: var(--ink-3); max-width: 44ch; line-height: 1.65; opacity: 0; animation: lp-fadeUp 0.7s ease 0.35s forwards; }
        .lp-actions { margin-top: 2.5rem; display: flex; gap: 1rem; flex-wrap: wrap; align-items: center; opacity: 0; animation: lp-fadeUp 0.7s ease 0.45s forwards; }
        .lp-btn-primary { font-family: var(--mono); font-size: 0.72rem; text-transform: uppercase; letter-spacing: 1px; padding: 14px 32px; background: var(--green); color: white; border: none; border-radius: var(--radius-ctl); cursor: pointer; transition: background 0.15s; }
        .lp-btn-primary:hover { background: var(--green-deep); }
        .lp-btn-ghost { font-family: var(--mono); font-size: 0.68rem; text-transform: uppercase; letter-spacing: 1px; color: var(--ink-3); background: none; border: none; border-bottom: 1px solid var(--line-2); padding: 14px 0; cursor: pointer; transition: color 0.15s; text-decoration: none; }
        .lp-btn-ghost:hover { color: var(--ink); border-color: var(--ink); }
        .lp-stats { margin-top: 5rem; display: flex; gap: 3rem; flex-wrap: wrap; padding-top: 2rem; border-top: 1px solid var(--line-2); opacity: 0; animation: lp-fadeUp 0.7s ease 0.55s forwards; }
        .lp-stat-num { font-family: var(--font); font-size: 2.2rem; font-weight: 800; letter-spacing: -0.03em; line-height: 1; }
        .lp-stat-label { font-family: var(--mono); font-size: 0.62rem; text-transform: uppercase; letter-spacing: 1px; color: var(--ink-3); margin-top: 0.3rem; }
        .lp-section { padding: 6rem 2.5rem; max-width: 1100px; margin: 0 auto; }
        .lp-section-label { font-family: var(--mono); font-size: 0.62rem; text-transform: uppercase; letter-spacing: 2px; color: var(--green); margin-bottom: 1rem; }
        .lp-h2 { font-family: var(--font); font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; letter-spacing: -0.03em; line-height: 1.15; max-width: 22ch; }
        .lp-h2 em { font-style: normal; color: var(--green); }
        .lp-problem-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; background: var(--line-2); border: 1px solid var(--line-2); margin-top: 3.5rem; }
        .lp-problem-card { background: var(--surface-2); padding: 2rem 1.75rem; }
        .lp-problem-num { font-family: var(--mono); font-size: 0.6rem; color: var(--ink-3); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 1rem; }
        .lp-problem-text { font-family: var(--font); font-size: 1.15rem; font-weight: 700; line-height: 1.45; letter-spacing: -0.02em; }
        .lp-problem-sub { margin-top: 0.75rem; font-size: 0.85rem; color: var(--ink-3); line-height: 1.6; }
        .lp-features-wrap { background: var(--surface-2); border-top: 1px solid var(--line-2); border-bottom: 1px solid var(--line-2); }
        .lp-features { max-width: 1100px; margin: 0 auto; padding: 6rem 2.5rem; }
        .lp-feature-row { display: grid; grid-template-columns: 1fr 1fr; gap: 5rem; align-items: center; padding: 4rem 0; border-bottom: 1px solid var(--line-2); }
        .lp-feature-row:last-child { border-bottom: none; padding-bottom: 0; }
        .lp-feature-row.flip { direction: rtl; }
        .lp-feature-row.flip > * { direction: ltr; }
        .lp-feature-tag { font-family: var(--mono); font-size: 0.6rem; text-transform: uppercase; letter-spacing: 1.5px; color: var(--green); margin-bottom: 0.75rem; }
        .lp-feature-title { font-family: var(--font); font-size: 1.85rem; font-weight: 800; letter-spacing: -0.03em; line-height: 1.2; margin-bottom: 1rem; }
        .lp-feature-title em { font-style: normal; color: var(--green); }
        .lp-feature-body { font-size: 0.95rem; color: var(--ink-3); line-height: 1.7; max-width: 38ch; }
        .lp-feature-body strong { color: var(--ink); font-weight: 600; }
        .lp-mock { background: var(--surface); border: 1.5px solid var(--line-2); border-radius: var(--radius); padding: 1.25rem; box-shadow: var(--shadow-lg); font-family: var(--mono); font-size: 0.72rem; }
        .lp-mock-bar { display: flex; align-items: center; gap: 0.5rem; padding-bottom: 0.75rem; border-bottom: 1px solid var(--line-2); margin-bottom: 0.75rem; }
        .lp-mock-dot { width: 8px; height: 8px; border-radius: 50%; }
        .lp-mock-cat { font-size: 0.65rem; text-transform: uppercase; letter-spacing: 0.8px; font-weight: 600; flex: 1; }
        .lp-mock-total { font-size: 0.78rem; font-weight: 600; }
        .lp-mock-row { display: flex; align-items: center; gap: 0.5rem; padding: 0.25rem 0; border-bottom: 1px solid var(--line); }
        .lp-mock-row:last-child { border-bottom: none; }
        .lp-mock-name { flex: 1; font-family: var(--font); font-size: 0.8rem; }
        .lp-mock-qty { color: var(--ink-3); font-size: 0.65rem; }
        .lp-mock-amt { width: 68px; text-align: right; }
        .lp-mock-div { border-top: 1.5px solid var(--line-2); margin: 0.75rem 0; }
        .lp-mock-grand { display: flex; justify-content: space-between; font-size: 0.82rem; font-weight: 700; }
        .lp-mock-mu-label { font-size: 0.6rem; text-transform: uppercase; letter-spacing: 1px; color: var(--ink-3); margin-bottom: 0.5rem; }
        .lp-mock-mu-row { display: flex; justify-content: space-between; align-items: center; padding: 0.22rem 0; border-bottom: 1px solid var(--line); font-size: 0.68rem; }
        .lp-mock-mu-name { color: var(--ink-3); font-size: 0.62rem; }
        .lp-mock-input { border: 1px solid var(--line-2); border-radius: var(--radius-ctl); padding: 2px 6px; font-family: var(--mono); font-size: 0.68rem; width: 52px; text-align: right; background: var(--surface-3); }
        .lp-mock-doc { background: var(--surface); border: 1.5px solid var(--line-2); border-radius: var(--radius); padding: 1.5rem; box-shadow: var(--shadow-lg); font-size: 0.78rem; }
        .lp-mock-doc-head { display: flex; justify-content: space-between; margin-bottom: 1rem; }
        .lp-mock-trading { font-family: var(--mono); font-size: 0.8rem; font-weight: 700; margin-bottom: 0.25rem; }
        .lp-mock-detail { font-size: 0.65rem; color: var(--ink-3); line-height: 1.6; }
        .lp-mock-doc-type { font-family: var(--mono); font-size: 0.75rem; font-weight: 700; text-align: right; margin-bottom: 0.35rem; }
        .lp-mock-doc-meta { font-family: var(--mono); font-size: 0.58rem; color: var(--ink-3); text-align: right; line-height: 1.8; }
        .lp-mock-doc-div { border-top: 1.5px solid var(--line-2); margin: 0.6rem 0; }
        .lp-mock-doc-lhd { display: flex; font-family: var(--mono); font-size: 0.57rem; text-transform: uppercase; letter-spacing: 0.7px; color: var(--ink-3); padding-bottom: 0.25rem; border-bottom: 1.5px solid var(--line-2); margin-bottom: 0.3rem; }
        .lp-mock-doc-ch { display: flex; font-family: var(--mono); font-size: 0.62rem; font-weight: 700; padding: 0.2rem 0.25rem; background: var(--surface-2); margin: 0.12rem -0.25rem; border-top: 1px solid var(--line); }
        .lp-mock-doc-line { display: flex; padding: 0.15rem 0; border-bottom: 1px solid var(--line); font-size: 0.7rem; }
        .lp-mock-doc-line.sun { color: var(--ink-3); font-style: italic; }
        .lp-mock-doc-amt { width: 64px; text-align: right; font-family: var(--mono); flex-shrink: 0; }
        .lp-mock-doc-total { display: flex; justify-content: space-between; padding: 0.2rem 0; font-family: var(--mono); font-size: 0.75rem; font-weight: 700; }
        .lp-how { max-width: 1100px; margin: 0 auto; padding: 6rem 2.5rem; }
        .lp-steps { display: grid; grid-template-columns: repeat(3, 1fr); gap: 3rem; margin-top: 3.5rem; }
        .lp-step-num { font-family: var(--font); font-size: 3rem; font-weight: 800; color: var(--line-2); line-height: 1; margin-bottom: 1rem; letter-spacing: -0.03em; }
        .lp-step-title { font-family: var(--font); font-size: 1.2rem; font-weight: 700; margin-bottom: 0.5rem; letter-spacing: -0.02em; }
        .lp-step-body { font-size: 0.88rem; color: var(--ink-3); line-height: 1.65; }
        .lp-cta-wrap { background: var(--header); color: var(--cream); padding: 6rem 2.5rem; text-align: center; }
        .lp-cta-inner { max-width: 580px; margin: 0 auto; }
        .lp-cta-h2 { font-family: var(--font); font-size: clamp(2rem, 4vw, 3rem); font-weight: 800; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 1.25rem; }
        .lp-cta-h2 em { font-style: normal; color: rgba(237,233,225,0.45); }
        .lp-cta-sub { font-size: 0.95rem; color: rgba(237,233,225,0.5); line-height: 1.65; margin-bottom: 2.5rem; }
        .lp-cta-note { margin-top: 1.25rem; font-family: var(--mono); font-size: 0.6rem; text-transform: uppercase; letter-spacing: 1px; color: rgba(237,233,225,0.2); }
        .lp-footer { padding: 2rem 2.5rem; border-top: 1px solid var(--line-2); display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; background: var(--paper); }
        .lp-footer-logo { font-family: var(--font); font-size: 1rem; font-weight: 800; letter-spacing: -0.02em; color: var(--ink-3); }
        .lp-footer-logo span { color: var(--green); }
        .lp-footer-note { font-family: var(--mono); font-size: 0.6rem; color: var(--ink-3); text-transform: uppercase; letter-spacing: 1px; }
        .lp-footer-links { display: flex; gap: 1rem; }
        .lp-footer-link { font-family: var(--mono); font-size: 0.6rem; color: var(--ink-3); text-decoration: none; text-transform: uppercase; letter-spacing: 1px; }
        .lp-footer-link:hover { color: var(--green); }
        .lp-consent { margin-top: 0.6rem; font-family: var(--mono); font-size: 0.6rem; color: rgba(237,233,225,0.5); line-height: 1.7; }
        .lp-consent-link { color: rgba(237,233,225,0.7); text-decoration: underline; }
        .lp-consent-link:hover { color: var(--cream); }
        .lp-reveal { opacity: 0; transform: translateY(20px); transition: opacity 0.6s ease, transform 0.6s ease; }
        .lp-reveal.visible { opacity: 1; transform: translateY(0); }
        @keyframes lp-fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        @media (max-width: 768px) {
          .lp-problem-grid { grid-template-columns: 1fr; }
          .lp-feature-row, .lp-feature-row.flip { grid-template-columns: 1fr; direction: ltr; gap: 2rem; }
          .lp-steps { grid-template-columns: 1fr; gap: 2rem; }
          .lp-stats { gap: 2rem; }
          .lp-nav, .lp-hero, .lp-section, .lp-features, .lp-how { padding-left: 1.25rem; padding-right: 1.25rem; }
        }
      `}</style>

      <div className="lp">
        {/* Nav */}
        <nav className="lp-nav">
          <span className="lp-logo">Akkord<span>.</span></span>
          <button className="lp-nav-cta" onClick={signIn}>Sign in →</button>
        </nav>

        {/* Hero */}
        <div className="lp-hero">
          <div className="lp-eyebrow">Project pricing for furniture makers</div>
          <h1 className="lp-h1">Price your work. <em>Know your numbers.</em></h1>
          <p className="lp-sub">Akkord helps furniture makers and joiners build accurate project costs, generate professional proposals, and stop undercharging for their craft.</p>
          <div className="lp-actions">
            <button className="lp-btn-primary" onClick={signIn}>Get started free →</button>
            <a className="lp-btn-ghost" href="#how-it-works">See how it works</a>
          </div>
          <div className="lp-stats">
            <div><div className="lp-stat-num">5 min</div><div className="lp-stat-label">To build a full project cost</div></div>
            <div><div className="lp-stat-num">£0</div><div className="lp-stat-label">To get started</div></div>
            <div><div className="lp-stat-num">100%</div><div className="lp-stat-label">Your data, your prices</div></div>
          </div>
        </div>

        {/* Problem */}
        <section className="lp-section">
          <div className="lp-section-label lp-reveal">The problem</div>
          <h2 className="lp-h2 lp-reveal">Most furniture makers are pricing <em>in the dark.</em></h2>
          <div className="lp-problem-grid">
            <div className="lp-problem-card lp-reveal">
              <div className="lp-problem-num">01</div>
              <div className="lp-problem-text">Spreadsheets that break, or nothing at all</div>
              <div className="lp-problem-sub">Pricing ends up scattered across notebooks, emails, and memory. There's no single source of truth for what a job actually costs.</div>
            </div>
            <div className="lp-problem-card lp-reveal">
              <div className="lp-problem-num">02</div>
              <div className="lp-problem-text">No separation between your costs and the client price</div>
              <div className="lp-problem-sub">Mark-up gets baked into line items, making it impossible to adjust cleanly or understand true margin per category.</div>
            </div>
            <div className="lp-problem-card lp-reveal">
              <div className="lp-problem-num">03</div>
              <div className="lp-problem-text">Proposals that look homemade</div>
              <div className="lp-problem-sub">The work is high quality. The quote that goes out often isn't. First impressions matter — especially at the prices quality furniture commands.</div>
            </div>
          </div>
        </section>

        {/* Features */}
        <div className="lp-features-wrap">
          <div className="lp-features">

            <div className="lp-feature-row lp-reveal">
              <div>
                <div className="lp-feature-tag">Project builder</div>
                <h3 className="lp-feature-title">Every cost, <em>in one place</em></h3>
                <p className="lp-feature-body">Build your project from scratch — timber, fixings, adhesives, site materials, labour. Real unit costs and quantities. The <strong>B&amp;I calculator</strong> works out Build &amp; Install time from your task list automatically.</p>
              </div>
              <div className="lp-mock">
                <div className="lp-mock-bar">
                  <div className="lp-mock-dot" style={{background:'var(--c-fixings)'}}></div>
                  <span className="lp-mock-cat">Fixings &amp; Hardware</span>
                  <span className="lp-mock-total">£84.00</span>
                </div>
                <div className="lp-mock-row"><span className="lp-mock-name">Blum Tandem 550H runners</span><span className="lp-mock-qty">5 × £9.20</span><span className="lp-mock-amt">£46.00</span></div>
                <div className="lp-mock-row"><span className="lp-mock-name">Screw packs</span><span className="lp-mock-qty">2 × £6.00</span><span className="lp-mock-amt">£12.00</span></div>
                <div className="lp-mock-row"><span className="lp-mock-name">Dominos</span><span className="lp-mock-qty">1 × £21.00</span><span className="lp-mock-amt">£21.00</span></div>
                <div className="lp-mock-row"><span className="lp-mock-name">L brackets</span><span className="lp-mock-qty">10 × £0.50</span><span className="lp-mock-amt">£5.00</span></div>
                <div className="lp-mock-div"></div>
                <div className="lp-mock-bar" style={{paddingBottom:0,borderBottom:'none',marginBottom:0}}>
                  <div className="lp-mock-dot" style={{background:'var(--c-adhesives)'}}></div>
                  <span className="lp-mock-cat">Labour</span>
                  <span className="lp-mock-total">£4,375.00</span>
                </div>
              </div>
            </div>

            <div className="lp-feature-row flip lp-reveal">
              <div>
                <div className="lp-feature-tag">Cost Proposal</div>
                <h3 className="lp-feature-title">A proposal that <em>reflects the work</em></h3>
                <p className="lp-feature-body">Click any line to show or hide it from the client. Hidden items roll up into Sundries automatically. <strong>Mark-up is applied at the output layer</strong> — your real costs stay private.</p>
              </div>
              <div className="lp-mock-doc">
                <div className="lp-mock-doc-head">
                  <div><div className="lp-mock-trading">Kelsey Smith Furniture</div><div className="lp-mock-detail">hello@kelseysmithfurniture.co.uk<br/>07957 326 986</div></div>
                  <div><div className="lp-mock-doc-type">Cost Proposal</div><div className="lp-mock-doc-meta">Ref Q-0041<br/>21 March 2026<br/>Sarah Johnson</div></div>
                </div>
                <div className="lp-mock-doc-div"></div>
                <div className="lp-mock-doc-lhd"><span style={{flex:1}}>Description</span><span className="lp-mock-doc-amt">Amount</span></div>
                <div className="lp-mock-doc-ch"><span style={{flex:1}}>Timber</span><span className="lp-mock-doc-amt">£240.00</span></div>
                <div className="lp-mock-doc-line"><span style={{flex:1}}>MFC sheets — Cworkshop</span><span className="lp-mock-doc-amt">£240.00</span></div>
                <div className="lp-mock-doc-ch"><span style={{flex:1}}>Fixings &amp; Hardware</span><span className="lp-mock-doc-amt">£100.80</span></div>
                <div className="lp-mock-doc-line"><span style={{flex:1}}>Blum Tandem runners</span><span className="lp-mock-doc-amt">£55.20</span></div>
                <div className="lp-mock-doc-line"><span style={{flex:1}}>Screw packs</span><span className="lp-mock-doc-amt">£14.40</span></div>
                <div className="lp-mock-doc-line sun"><span style={{flex:1}}>Sundries</span><span className="lp-mock-doc-amt">£31.20</span></div>
                <div className="lp-mock-doc-ch"><span style={{flex:1}}>Labour</span><span className="lp-mock-doc-amt">£4,375.00</span></div>
                <div className="lp-mock-doc-line"><span style={{flex:1}}>Build &amp; Install</span><span className="lp-mock-doc-amt">£3,325.00</span></div>
                <div className="lp-mock-doc-line"><span style={{flex:1}}>Project Admin</span><span className="lp-mock-doc-amt">£350.00</span></div>
                <div className="lp-mock-doc-div"></div>
                <div className="lp-mock-doc-total"><span>Total</span><span>£4,715.80</span></div>
              </div>
            </div>

            <div className="lp-feature-row lp-reveal">
              <div>
                <div className="lp-feature-tag">Mark-up</div>
                <h3 className="lp-feature-title">Your margin, <em>your business</em></h3>
                <p className="lp-feature-body">Set default mark-up per category in your account. Override per project. The client never sees your trade costs. <strong>Labour mark-up defaults to zero</strong> because your day rate already includes your margin.</p>
              </div>
              <div className="lp-mock">
                <div className="lp-mock-mu-label">Mark-up — visible to you only</div>
                {[['Timber','20 %'],['Fixings & Hardware','20 %'],['Adhesives & Finishes','20 %'],['Site Materials','20 %'],['Labour','0 %']].map(([name, val]) => (
                  <div key={name} className="lp-mock-mu-row">
                    <span className="lp-mock-mu-name">{name}</span>
                    <input className="lp-mock-input" defaultValue={val} readOnly />
                  </div>
                ))}
                <div className="lp-mock-div"></div>
                <div className="lp-mock-grand"><span>Client total</span><span>£5,082.40</span></div>
              </div>
            </div>

          </div>
        </div>

        {/* How it works */}
        <section className="lp-how" id="how-it-works">
          <div className="lp-section-label lp-reveal">How it works</div>
          <h2 className="lp-h2 lp-reveal">From project to <em>proposal</em> in minutes</h2>
          <div className="lp-steps">
            {[
              ['01','Build your project cost','Add materials across every category — timber, fixings, adhesives, site materials. Enter real unit costs and quantities. Use the B&I calculator to work out labour days automatically.'],
              ['02','Set your mark-up','Apply mark-up per category. Set defaults once in your account, override per project. Your trade costs stay private — the client sees only the proposal price.'],
              ['03','Generate the proposal','Click any line to show or hide it from the client. Add a project description, payment terms, and notes. Print or download a clean PDF with your trading name and logo.'],
            ].map(([num, title, body]) => (
              <div key={num} className="lp-reveal">
                <div className="lp-step-num">{num}</div>
                <div className="lp-step-title">{title}</div>
                <div className="lp-step-body">{body}</div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <div className="lp-cta-wrap">
          <div className="lp-cta-inner">
            <h2 className="lp-cta-h2">Ready to price with <em>confidence?</em></h2>
            <p className="lp-cta-sub">Akkord is free to get started. Sign in with your Google account and build your first project in minutes.</p>
            <button className="lp-btn-primary" onClick={signIn}>Get started free →</button>
            <div className="lp-cta-note">No credit card required · Sign in with Google</div>
            <div className="lp-consent">
              By continuing, you agree to our{' '}
              <a href={process.env.REACT_APP_TERMS_URL || '#'} target="_blank" rel="noopener noreferrer" className="lp-consent-link">Terms of Service</a>
              {' '}and{' '}
              <a href={process.env.REACT_APP_PRIVACY_URL || '#'} target="_blank" rel="noopener noreferrer" className="lp-consent-link">Privacy Policy</a>.
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="lp-footer">
          <div className="lp-footer-logo">Akkord<span>.</span></div>
          <div className="lp-footer-note">Project pricing for furniture makers</div>
          <div className="lp-footer-links">
            <a href={process.env.REACT_APP_TERMS_URL || '#'} target="_blank" rel="noopener noreferrer" className="lp-footer-link">Terms</a>
            <a href={process.env.REACT_APP_PRIVACY_URL || '#'} target="_blank" rel="noopener noreferrer" className="lp-footer-link">Privacy</a>
          </div>
        </footer>
      </div>

      {/* Sign-in modal */}
      {showSignIn && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(33,28,23,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}
          onClick={() => { setShowSignIn(false); setMagicSent(false); setEmail('') }}>
          <div style={{ background: 'var(--surface)', border: '1px solid var(--line-2)', borderRadius: 'var(--radius)', padding: '2.25rem 2rem', width: '100%', maxWidth: '360px', boxShadow: 'var(--shadow-lg)', textAlign: 'center' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontFamily: 'var(--font)', fontSize: '1.6rem', fontWeight: 800, letterSpacing: '-0.03em', marginBottom: '0.35rem' }}>
              Akkord<span style={{ color: 'var(--green)' }}>.</span>
            </div>
            <p style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '1.5rem' }}>
              Sign in to continue
            </p>

            {magicSent ? (
              <div>
                <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>✉️</div>
                <p style={{ fontFamily: 'var(--font)', fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem' }}>Check your email</p>
                <p style={{ fontSize: '0.82rem', color: 'var(--ink-3)', lineHeight: 1.6, marginBottom: '1rem' }}>
                  We sent a sign-in link to <strong>{email}</strong>
                </p>
                <button style={{ background: 'none', border: 'none', fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--ink-3)', cursor: 'pointer', textDecoration: 'underline' }}
                  onClick={() => { setMagicSent(false); setEmail('') }}>← Try another method</button>
              </div>
            ) : (
              <>
                <button
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.75rem', width: '100%', padding: '0.75rem 1rem', background: 'var(--surface)', border: '1.5px solid var(--line-2)', borderRadius: 'var(--radius-ctl)', fontSize: '0.9rem', fontWeight: 500, color: 'var(--ink)', cursor: 'pointer', marginBottom: '0.75rem' }}
                  onClick={signInGoogle}>
                  <svg width="18" height="18" viewBox="0 0 18 18">
                    <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
                    <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"/>
                    <path fill="#FBBC05" d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z"/>
                    <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58z"/>
                  </svg>
                  Sign in with Google
                </button>

                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '0.25rem 0 0.75rem' }}>
                  <div style={{ flex: 1, height: '1px', background: 'var(--line-2)' }} />
                  <span style={{ fontFamily: 'var(--mono)', fontSize: '0.6rem', color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '1px' }}>or</span>
                  <div style={{ flex: 1, height: '1px', background: 'var(--line-2)' }} />
                </div>

                <form onSubmit={signInMagic}>
                  <input
                    className="ak-input"
                    style={{ width: '100%', marginBottom: '0.6rem', fontSize: '0.9rem' }}
                    type="email" placeholder="your@email.com" value={email}
                    onChange={e => setEmail(e.target.value)} required
                  />
                  <button
                    className="ak-btn ak-btn--primary ak-btn--block"
                    style={{ fontSize: '0.9rem', padding: '0.75rem 1rem' }}
                    type="submit" disabled={magicLoading}>
                    {magicLoading ? 'Sending…' : 'Send sign-in link →'}
                  </button>
                  {magicError && (
                    <p style={{ marginTop: '0.6rem', fontSize: '0.75rem', color: '#c0392b', fontFamily: 'var(--mono)', textAlign: 'center' }}>
                      {magicError}
                    </p>
                  )}
                </form>
              </>
            )}

            <p style={{ marginTop: '1.25rem', fontSize: '0.62rem', color: 'var(--ink-3)', fontFamily: 'var(--mono)', lineHeight: 1.6 }}>
              By continuing, you agree to our{' '}
              <a href={process.env.REACT_APP_TERMS_URL || '#'} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green)', textDecoration: 'none' }}>Terms</a>
              {' '}and{' '}
              <a href={process.env.REACT_APP_PRIVACY_URL || '#'} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--green)', textDecoration: 'none' }}>Privacy Policy</a>.
            </p>
          </div>
        </div>
      )}
    </>
  )
}
